<template>
  <div class="details__wrapper">
    <button
      class="details"
      type="button"
      @click="showModal = true"
    >
      <span>Mehr Informationen</span>
      <Icon id="info" />
    </button>

    <Modal v-on:close="() => showModal = false" v-if="showModal">
      <h2 v-if="headline" class="size--xxl">{{ headline }}</h2>
      <div v-html="text"></div>
      <h2 v-if="headline2" class="size--xxl odd">{{ headline2 }}</h2>
      <div v-if="text2" v-html="text2"></div>
      <div
        v-if="image"
        class="info-image"
        :style="`background-image: url(${require(`@/assets/img/${image}`)});`"
      ></div>
    </Modal>
  </div>
</template>

<script>
import Icon from '@/components/Icon.vue';
import Modal from '@/components/Modal.vue';

export default {
  components: {
    Icon,
    Modal,
  },
  props: {
    headline: {
      validator: prop => typeof prop === 'string' || prop === null,
      required: true,
    },
    text: {
      validator: prop => typeof prop === 'string' || prop === null,
      required: true,
    },
    headline2: {
      validator: prop => typeof prop === 'string' || prop === null,
      required: false,
    },
    text2: {
      validator: prop => typeof prop === 'string' || prop === null,
      required: false,
    },
    image: {
      validator: prop => typeof prop === 'string' || prop === null,
      required: false,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
};
</script>

<style scoped lang="scss">
.details__wrapper {
  h2.odd {
    padding-top: 20px;
  }
  .info-image {
    background: no-repeat center;
    background-size: contain;
    height: 400px;
    flex-basis: 400px;
  }
}
.details {
  background: transparent;
  margin: 0px auto 40px;
  padding: 10px;
  display: block;
  cursor: pointer;
  color: $color-secondary-light;
  border: 0;

  span {
    margin-right: 8px;
    display: inline-block;
    border-bottom: 1px solid $color-secondary-light;
  }

  .icon {
    width: 22px;
    height: 22px;
    color: $color-primary;
    transform: translateY(5px);
  }
}
</style>
